import styled, { css } from 'styled-components';
import {
  ColumnOneDesktop,
  ColumnTwoDesktop,
  ItemDesktop,
  WrapperList,
  WrapperSkeletonListDesktop,
} from '@components/ui/JourneyList/JourneyListSkeletonStyles';

const heightHeader = '176px';
const marginInputSearch = '32px';
export const WrapperStyledFuelGridContainer = WrapperSkeletonListDesktop;

export const Wrapper = WrapperList;

export const Item = ItemDesktop;

export const ColumnOne = ColumnOneDesktop;
export const ColumnTwo = ColumnTwoDesktop;

export const WrapperMap = styled.div`
  ${({ theme }) => css`
    height: calc(
      105vh - ${heightHeader} - ${marginInputSearch} - ${theme.spacing.km6}
    );

    fuel-skeleton {
      margin-top: -95px;
      z-index: 4;

      @media screen and (max-width: 1275px) {
        margin-top: ${theme.spacing.km0};
      }
    }
  `}
`;

export const WrapperOriginAndDestination = styled.div`
  ${({ theme }) => css`
    max-width: 400px;
    display: grid;
    grid-template-columns: 8px 1fr;
    gap: ${theme.padding.km2};
    min-height: 58px;
  `}
`;
